(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
      clearTimeout(this.exitTimer);
    }

    onEnter() {
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }
  }
  customElements.define('header-wrapper', HeaderWrapper);

  /* Sticky header (plain position: sticky, like Focal) with a collapsible menu.
     - Stickiness is pure CSS: the header section sticks to top: 0. Nothing is fixed or
       absolute and nothing overlaps the sections below. No spacer, no slide-in.
     - The announcement bar is NOT touched: it scrolls away like normal and shows again
       when you are back at the very top.
     - Only the menu row changes: it collapses into the hamburger once you have scrolled
       COLLAPSE_AFTER px past the announcement bar, and expands again when you are within
       EXPAND_BELOW px of the very top (the gap prevents flicker). The header keeps its
       full (menu expanded) height reserved, so the page never moves while the menu
       collapses or expands.
     The "show on scroll up" setting is not needed any more: the header is always visible. */
  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
      this.COLLAPSE_AFTER = 60;
      this.EXPAND_BELOW = 40;
      this.ticking = false;
      this.bars = [];
      this.barsHeight = 0;
      this.headerHeight = 0;
      this.compactHeight = 0;
      this.settleUntil = 0;
      this.flattenedParent = null;
      this.useFixed = false;
    }

    connectedCallback() {
      super.connectedCallback();

      // Sections directly above the header (announcement bar). Only measured, never changed.
      this.bars = [];
      let el = this.header.previousElementSibling;
      while (el && el.classList.contains('shopify-section')) {
        this.bars.unshift(el);
        el = el.previousElementSibling;
      }

      // Measure the natural (menu expanded) sizes first
      this.measureMenu();
      this.headerHeight = this.naturalHeaderHeight();
      this.measureBars();

      this.freeStickyParents();

      // First pass (page load / restored scroll position) must not animate
      this.header.classList.add('shopify-section-header-snap', 'shopify-section-header-pinned');
      this.measureCompact();
      this.applyReserve();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      if (window.ResizeObserver) {
        // The announcement bar can change height (text wraps, slider changes)
        if (this.bars.length) {
          this.barObserver = new ResizeObserver(() => {
            this.measureBars();
            this.update();
          });
          this.bars.forEach((bar) => this.barObserver.observe(bar));
        }

        // The header can change height while styles and fonts are still loading
        // (the theme loads some stylesheets after this script runs)
        this.headerObserver = new ResizeObserver(() => this.onHeaderResize());
        this.headerObserver.observe(this);
      }

      this.onLoadHandler = () => this.remeasure();
      window.addEventListener('load', this.onLoadHandler);

      this.update();
      this.endSnap();

      // Web fonts can change how the menu wraps, so measure again once they are ready
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (this.isConnected) this.remeasure();
        });
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('load', this.onLoadHandler);
      cancelAnimationFrame(this.frame);
      clearTimeout(this.resizeTimer);
      clearTimeout(this.anchorTimer);
      if (this.barObserver) this.barObserver.disconnect();
      if (this.headerObserver) this.headerObserver.disconnect();

      if (this.flattenedParent) this.flattenedParent.style.removeProperty('display');

      if (this.header) {
        this.header.classList.remove(
          'shopify-section-header-pinned',
          'shopify-section-header-fixed',
          'shopify-section-header-sticky',
          'shopify-section-header-compact',
          'shopify-section-header-menu-open',
          'shopify-section-header-snap'
        );
        ['--header-height-full', '--header-height-compact', '--header-menu-height'].forEach((prop) => {
          this.header.style.removeProperty(prop);
        });
      }
      document.body.classList.remove('shopify-body-section-header-sticky');
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      this.frame = requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.remeasure(), 150);
    }

    endSnap() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.header.classList.remove('shopify-section-header-snap');
        });
      });
    }

    // Height of the header element itself (not its section wrapper, which has a reserved min-height)
    naturalHeaderHeight() {
      return this.getBoundingClientRect().height;
    }

    // Total height of the announcement bar(s) above the header: where the header sticks from
    measureBars() {
      this.barsHeight = this.bars.reduce((sum, bar) => sum + bar.getBoundingClientRect().height, 0);
    }

    // Layout height of the header section in both states. The section is given exactly
    // the height of what is shown (CSS animates between them), so no empty band is left
    // under a collapsed header.
    applyReserve() {
      this.header.style.setProperty('--header-height-full', this.headerHeight + 'px');
      if (this.compactHeight) {
        this.header.style.setProperty('--header-height-compact', this.compactHeight + 'px');
      }
    }

    // Height of the header with the menu row collapsed (call with transitions off)
    measureCompact() {
      const cl = this.header.classList;
      const hadCompact = cl.contains('shopify-section-header-compact');
      const hadOpen = cl.contains('shopify-section-header-menu-open');
      cl.add('shopify-section-header-compact');
      cl.remove('shopify-section-header-menu-open');
      this.compactHeight = this.naturalHeaderHeight();
      if (!hadCompact) cl.remove('shopify-section-header-compact');
      if (hadOpen) cl.add('shopify-section-header-menu-open');
    }

    // position: sticky silently does nothing if an ancestor clips overflow, or if the
    // parent of the header is only as tall as the header. Fix both without moving anything.
    freeStickyParents() {
      // overflow: hidden on an ancestor stops sticky. overflow: clip clips the same way
      // but does not create a scroll container.
      // (html and body are skipped: clip there would stop the page from scrolling.
      // If they block sticky, the fallback in update() takes over.)
      // body with overflow-x: hidden becomes its own scroll container and stops sticky
      // (the page itself scrolls, so the header just scrolls away). clip fixes that.
      const bodyStyles = window.getComputedStyle(document.body);
      if (bodyStyles.overflowX !== 'visible' || bodyStyles.overflowY !== 'visible') {
        document.body.style.setProperty('overflow-x', 'clip', 'important');
        document.body.style.setProperty('overflow-y', 'visible', 'important');
      }

      let node = this.header.parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        const styles = window.getComputedStyle(node);
        if (styles.overflowX === 'hidden' || styles.overflowY === 'hidden') {
          node.style.setProperty('overflow-x', 'clip');
          node.style.setProperty('overflow-y', 'clip');
        }
        node = node.parentElement;
      }

      // A wrapper that only holds the header group would limit how long the header can stick.
      // Let its children take part in the parent's layout instead (display: contents).
      const parent = this.header.parentElement;
      if (parent && parent !== document.body && parent !== document.documentElement) {
        const needed = this.barsHeight + this.headerHeight;
        if (parent.getBoundingClientRect().height < needed + window.innerHeight * 0.5) {
          parent.style.setProperty('display', 'contents');
          this.flattenedParent = parent;
        }
      }
    }

    // Real height of the menu row, so it animates to its exact size (smooth, not a jump)
    measureMenu() {
      const menu = this.querySelector('.header__inline-menu');
      if (!menu) return;

      this.header.style.setProperty('--header-menu-height', '9999px');
      const height = menu.offsetHeight;

      if (height) {
        this.header.style.setProperty('--header-menu-height', height + 'px');
      } else {
        this.header.style.removeProperty('--header-menu-height');
      }
    }

    // Keep the reserved height equal to the real expanded header height. Ignored while the
    // menu is collapsed or still animating, so the page never twitches during the animation.
    onHeaderResize() {
      if (this.header.classList.contains('shopify-section-header-compact')) return;
      if (performance.now() < this.settleUntil) return;

      const height = this.naturalHeaderHeight();

      if (Math.abs(height - this.headerHeight) > 0.5) {
        this.headerHeight = height;
        this.measureMenu();
        this.applyReserve();
      }
    }

    // Re-measure the expanded header (resize, fonts). Done within one frame with
    // transitions off, so the user never sees the temporary expanded state.
    remeasure() {
      const classes = this.header.classList;
      const wasCompact = classes.contains('shopify-section-header-compact');

      classes.add('shopify-section-header-snap');
      classes.remove('shopify-section-header-compact');

      this.measureMenu();
      this.headerHeight = this.naturalHeaderHeight();
      this.measureBars();
      this.measureCompact();
      this.applyReserve();

      if (wasCompact) classes.add('shopify-section-header-compact');
      this.endSnap();
    }

    // While the header section changes height, stop the browser from "correcting" the
    // scroll position for it (scroll anchoring), which would fight the animation.
    holdAnchor() {
      const root = document.documentElement;
      root.style.setProperty('overflow-anchor', 'none');
      clearTimeout(this.anchorTimer);
      this.anchorTimer = setTimeout(() => root.style.removeProperty('overflow-anchor'), 1000);
    }

    update() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // The header is stuck once the announcement bar has scrolled out of view
      const stuck = scrollTop > this.barsHeight + 2;
      this.header.classList.toggle('shopify-section-header-sticky', stuck);
      document.body.classList.toggle('shopify-body-section-header-sticky', stuck);

      // Safety net: if the browser did not keep the header stuck (a parent of the header
      // blocks position: sticky), pin it with position: fixed instead. The section keeps
      // its reserved height, so nothing shifts and nothing overlaps.
      if (stuck && !this.useFixed && this.header.getBoundingClientRect().top < -1) {
        this.useFixed = true;
      }
      this.header.classList.toggle('shopify-section-header-fixed', this.useFixed && stuck);

      const compact = this.header.classList.contains('shopify-section-header-compact');

      if (!compact && scrollTop > this.barsHeight + this.COLLAPSE_AFTER) {
        this.settleUntil = performance.now() + 900;
        this.holdAnchor();
        this.header.classList.add('shopify-section-header-compact');
      } else if (compact && scrollTop < this.EXPAND_BELOW) {
        this.settleUntil = performance.now() + 900;
        this.holdAnchor();
        this.header.classList.remove('shopify-section-header-compact', 'shopify-section-header-menu-open');
      }
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid-grid"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
 
    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      document.head.appendChild(script)
    }

    this.slider

    setTimeout(() => { 
      this.slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      this.slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      this.slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)

    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })
    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }

}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();
})();
